import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from "react-icons/fa";

/**
 * Reusable password input field with visibility toggle.
 * Used across auth forms to keep password UI consistent.
 */
export default function PasswordInput({
  id,
  name,
  value,
  onChange,
  label,
  required = true,
  placeholder = "",
  autoComplete,
  ariaInvalid = false,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="form-group password-group">
      <label htmlFor={id}>
        {required && <span className="required-star">*</span>}
        {label}
      </label>

      <div className="password-wrapper">
        <input
          id={id}
          name={name}
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          aria-invalid={ariaInvalid}
        />

        <button
          type="button"
          className="toggle-password"
          onClick={togglePasswordVisibility}
          aria-label={
            showPassword
              ? t(["common.hidePassword", "hide_password"])
              : t(["common.showPassword", "show_password"])
          }
          title={
            showPassword
              ? t(["common.hidePassword", "hide_password"])
              : t(["common.showPassword", "show_password"])
          }
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
    </div>
  );
}
